import React, { Component } from 'react';
import { Link } from "react-router-dom";
import AuthService from '../../services/AuthService.js'

export class AutodiagnosticoConfirmacionForm extends Component {
    static displayName = AutodiagnosticoConfirmacionForm.name;
    crearFormulario() {
        if (AuthService.getToken().auxId > 0) {
            return (
                <div>
                    <h4>Gracias</h4>
                    <p>El formulario ha sido diligenciado correctamente.</p>
                    <p>Si lo desea puede <Link to='/' >volver al menú principal</Link></p>
                </div>
            );
        } else { 
            return (
                <div>
                    <h4>Gracias</h4>
                    <p>El formulario ha sido diligenciado correctamente.</p>
                    <p>Si lo desea puede <Link to='/autodiagnostico' >realizar otra encuesta</Link> o <Link to='/' >volver al menú principal</Link></p>
                </div>
            );
        }
    }
    render() {
        return (
             this.crearFormulario()
        );
    }
}
